import { l } from 'client/Other/Translation'

import { changePassword, getCognitoUser, isCognitoUser, sendDeleteAccountEmail } from '../api/cognito'
import * as api from '../api/user'
import { UserInterface } from '../Interfaces/UserInterface'
import { UserActions } from './actionTypes'
import { addGeneralError } from './error'
import { actionCreatorAsync, AsyncAction } from './index'

export const PASSWORD_UPDATE_API_ERROR = 'passwordUpdateAPIError'

export const getUser = (): AsyncAction<UserInterface> => {
  return actionCreatorAsync<UserInterface>(UserActions.GET_USER, async () => await getCognitoUser())
}

export const updatePassword = (payload) => {
  return async (dispatch) => {
    try {
      await changePassword(payload.currentPassword, payload.newPassword)
    } catch (e) {
      dispatch(addGeneralError({ message: l('error.password.invalid'), key: PASSWORD_UPDATE_API_ERROR }))
    }
  }
}

export const deleteAccount = (locale: string) => {
  return async () => {
    try {
      await sendDeleteAccountEmail(locale)
    } catch (err) {
      console.error(err)
    }
  }
}
